import { createSelector } from '@reduxjs/toolkit';
import { getDefaultObject } from '../utils/apiUtils';

const selectDefaultValuesState = (state) => state.inputForm.defaultValues;

const initialState = {
  defaultValues: {},
  loading: false,
  error: null,
};

const inputFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_DEFAULT_VALUES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_DEFAULT_VALUES_SUCCESS':
      return { ...state, loading: false, defaultValues: { ...state.defaultValues, [action.payload.entityName]: action.payload.defaultValues } };
    case 'FETCH_DEFAULT_VALUES_FAILURE':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

const fetchDefaultValuesRequest = () => ({ type: 'FETCH_DEFAULT_VALUES_REQUEST' });
const fetchDefaultValuesSuccess = (entityName, defaultValues) => ({ type: 'FETCH_DEFAULT_VALUES_SUCCESS', payload: { entityName, defaultValues } });
const fetchDefaultValuesFailure = (error) => ({ type: 'FETCH_DEFAULT_VALUES_FAILURE', payload: error });

export const fetchDefaultValues = (entityName) => {
  return async (dispatch) => {
    dispatch(fetchDefaultValuesRequest());
    try {
      const defaultObject = await getDefaultObject(entityName);
      dispatch(fetchDefaultValuesSuccess(entityName, defaultObject));
    }
    catch (error) {
      dispatch(fetchDefaultValuesFailure(error.response?.data || 'An error occurred.'));
    }
  };
};

export const selectDefaultValues = createSelector(
  [selectDefaultValuesState, (state, entityName) => entityName],
  (defaultValues, entityName) => defaultValues[entityName]
);

export const selectInputFormLoading = (state) => state.inputForm.loading;
export const selectInputFormError = (state) => state.inputForm.error;

export default inputFormReducer;